import React from "react";

import { Stack } from "@mui/material";
import { HorizontalNavBar, type HorizontalNavBarProps } from "components/HorizontalNavBar/HorizontalNavBar";
import { Routes } from "constants/routes";
import { useAccountSelector, useDealIdSelector, useDealTypeSelect } from "store";

export const ReportTabs: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dealId = useDealIdSelector();
  const dealIdStr = dealId?.toString() || "";
  const { show_debt } = useAccountSelector() || {};
  const isDebt = useDealTypeSelect() === "debt";

  const tabs: HorizontalNavBarProps["tabs"] = [
    {
      label: "General",
      value: "general",
      to: Routes.dealReport.replace(":deal_id", dealIdStr),
      matchRouts: [Routes.dealReport]
    },
    {
      label: "Debt Report",
      value: "debt",
      to: Routes.dealDebtReport.replace(":deal_id", dealIdStr),
      matchRouts: [Routes.dealDebtReport],
      disabled: !isDebt
    }
  ];

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {show_debt && <HorizontalNavBar tabs={tabs} />}
      <Stack
        sx={{
          width: "100%",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          marginTop: "20px",
          height: 0
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};
